export function qboVendorDetailUrl(vendorId: string): string {
  return `https://qbo.intuit.com/app/vendordetail?nameId=${encodeURIComponent(vendorId)}`
}

export function resolveQboVendorId(
  vendorName: string | null | undefined,
  vendors: Array<{ id: string; display_name: string }>,
  loadingQbo: boolean,
): string | null {
  if (loadingQbo) return null
  const trimmed = (vendorName ?? '').trim()
  if (!trimmed) return null
  return vendors.find((v) => v.display_name === trimmed)?.id ?? null
}
